import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faUser,
    faTruck,
    faCalendar,
    faTrash,
    faMapMarkerAlt,
    faFileInvoice
} from "@fortawesome/free-solid-svg-icons";

import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

import { getProductos } from "../../../services/productoservice";
import {
    getCotizaciones,
    guardarCotizacion
} from "../../../services/cotizacionservice";
import { getClientes } from "../../../services/clienteservice";

import "./agregarcotizacion.css";

export default function AgregarCotizacion() {

    const navigate = useNavigate();

    const [productos, setProductos] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [carrito, setCarrito] = useState([]);

    const [clienteId, setClienteId] = useState(0);
    const [clienteBusqueda, setClienteBusqueda] = useState("");
    const [mostrarClientes, setMostrarClientes] = useState(false);

    const [servicio] = useState("ALQUILER DE MOBILIARIO");

    const [direccion, setDireccion] = useState("");
    const [documento, setDocumento] = useState("");
    const [correlativo, setCorrelativo] = useState("");

    const [montaje, setMontaje] = useState("");
    const [desmontaje, setDesmontaje] = useState("");

    const [busqueda, setBusqueda] = useState("");
    const [mostrarLista, setMostrarLista] = useState(false);


    const [mostrarModalItem, setMostrarModalItem] = useState(false);

    const [itemDescripcion, setItemDescripcion] = useState("");
    const [itemPrecio, setItemPrecio] = useState("");
    const [itemCantidad, setItemCantidad] = useState(1);

    const [transporte, setTransporte] = useState(0);

    const IGV = 0.18;

    const getNombreItem = (p) => {
        return p.personalizado ? p.descripcion : p.nombre;
    };

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {

        const productosData = await getProductos();
        setProductos(productosData || []);

        const clientesData = await getClientes();
        setClientes(clientesData || []);

        const cotizacionesData = await getCotizaciones();

        const ultimoId = Math.max(
            ...(cotizacionesData || []).map(c => Number(c.idcotizacion)),
            0
        );

        setCorrelativo(
            `COT-${String(ultimoId + 1).padStart(6, "0")}`
        );
    };

    const clientesFiltrados = clientes.filter(c => {
        const txt = `${c.nombre || ""} ${c.apellido || ""} ${c.razonsocial || ""}`.toLowerCase();
        return txt.includes(clienteBusqueda.toLowerCase());
    });

    const productosFiltrados = productos.filter(p =>
        p.nombre?.toLowerCase().includes(busqueda.toLowerCase())
    );

    const seleccionarCliente = (c) => {
        setClienteId(Number(c.idcliente));

        setClienteBusqueda(
            `${c.nombre || ""} ${c.apellido || ""}`.trim() || c.razonsocial || ""
        );

        setMostrarClientes(false);

        setDireccion(c.direccion || "");;

        setDocumento(c.documento || "");;
    };

    const agregarProducto = (p) => {
        const existe = carrito.find(x => x.idproducto === p.idproducto);

        if (existe) {
            setCarrito(carrito.map(x =>
                x.idproducto === p.idproducto
                    ? { ...x, cantidad: x.cantidad + 1 }
                    : x
            ));
        } else {
            setCarrito([...carrito, { ...p, cantidad: 1 }]);
        }
    };

    const agregarItemPersonalizado = () => {

        if (!itemDescripcion.trim()) {
            return toast.error("Ingrese una descripción");
        }

        if (!itemPrecio || Number(itemPrecio) <= 0) {
            return toast.error("Ingrese un precio válido");
        }

        const nuevoItem = {
            idproducto: null,
            personalizado: 1,
            descripcion: itemDescripcion.trim(),
            precioventa: Number(itemPrecio) || 0,
            cantidad: Number(itemCantidad) || 1
        };

        setCarrito(prev => [...prev, nuevoItem]);

        setItemDescripcion("");
        setItemPrecio("");
        setItemCantidad(1);

        setMostrarModalItem(false);
    };

    const cambiarCantidad = (index, val) => {
        setCarrito(prev =>
            prev.map((x, i) =>
                i === index ? { ...x, cantidad: Number(val) } : x
            )
        );
    };

    const eliminar = (index) => {
        setCarrito(prev =>
            prev.filter((_, i) => i !== index)
        );
    };

    const subtotalProductos = carrito.reduce((acc, item) => {
        const precio = Number(item.precioventa || 0);
        const cantidad = Number(item.cantidad || 0);

        return acc + (precio * cantidad);
    }, 0);

    const subtotal = subtotalProductos + Number(transporte || 0);

    const igv = subtotal * IGV;

    const total = subtotal + igv;

    const guardar = async () => {
        if (!clienteId) return toast.error("Seleccione cliente");
        if (carrito.length === 0) return toast.error("Agregue productos");

        const user = JSON.parse(localStorage.getItem("user"));

        const payload = {
            idcliente: Number(clienteId),
            idusuario: user?.idusuario || 1,

            servicio,
            direccion,
            montaje,
            desmontaje,

            transporte: Number(transporte || 0),

            subtotal,
            igv,
            total,

            detalles: carrito.map(p => ({
                idproducto: p.idproducto,
                personalizado: p.personalizado ? 1 : 0,
                descripcion: p.personalizado ? p.descripcion : null,
                cantidad: Number(p.cantidad),
                precio: Number(p.precioventa),
                subtotal: Number(p.precioventa) * Number(p.cantidad)
            }))
        };

        const res = await guardarCotizacion(payload);

        if (res.status === "success") {
            toast.success("Cotización guardada");
            navigate("/inicio/cotizacion");
        } else {
            toast.error("Error al guardar");
        }
    };

    return (
        <div className="cotizacion">

            <ToastContainer />

            {/* PRODUCTO */}
            <div className="productos-toolbar">

                <div className="search-box">
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />

                    <input
                        placeholder="Buscar producto..."
                        value={busqueda}
                        onChange={(e) => {
                            setBusqueda(e.target.value);
                            setMostrarLista(true);
                        }}
                    />

                    {mostrarLista && busqueda && productosFiltrados.length > 0 && (
                        <div className="dropdown">
                            {productosFiltrados.slice(0, 6).map((p) => (
                                <div
                                    key={p.idproducto}
                                    className="dropdown-item"
                                    onClick={() => {
                                        agregarProducto(p);
                                        setBusqueda("");
                                        setMostrarLista(false);
                                    }}
                                >
                                    {p.nombre}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <button
                    type="button"
                    className="btn-item-personalizado"
                    onClick={() => setMostrarModalItem(true)}
                >
                    + Item personalizado
                </button>

            </div>

            {/* TABLE */}
            <div className="cotizacion-table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Producto</th>
                            <th>Precio</th>
                            <th>Cantidad</th>
                            <th>Subtotal</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {carrito.map((p, index) => (
                            <tr key={`${p.idproducto || "custom"}-${index}`}>
                                <td>{getNombreItem(p)}</td>
                                <td>{p.precioventa}</td>
                                <td>
                                    <input
                                        type="number"
                                        value={p.cantidad}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            cambiarCantidad(index, val === "" ? 0 : val);
                                        }}
                                    />
                                </td>
                                <td>
                                    {(p.precioventa * p.cantidad).toFixed(2)}
                                </td>
                                <td>
                                    <button
                                        className="cotizacion-delete-btn"
                                        onClick={() => eliminar(index)}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>
                            </tr>


                        ))}

                        {/* 👇 ESPACIO VACÍO SOLO CUANDO NO HAY ITEMS */}
                        {carrito.length === 0 && (
                            <tr>
                                <td colSpan="5" style={{ height: "100px" }} />
                            </tr>
                        )}

                    </tbody>

                    <tfoot>
                        <tr>

                            <td colSpan="2">
                                Transporte
                            </td>

                            <td></td>

                            <td>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={transporte}
                                    onChange={(e) => setTransporte(e.target.value)}
                                    className="transport-input"
                                />
                            </td>

                            <td></td>

                        </tr>

                        <tr>
                            <td colSpan="5">
                                <div className="summary">
                                    <div>Subtotal: {subtotal.toFixed(2)}</div>
                                    <div>IGV: {igv.toFixed(2)}</div>
                                    <div className="total">
                                        Total: {(subtotal + igv).toFixed(2)}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* FORM */}
            <div className="bottom">

                <div className="topcontainer">

                    {/* CORRELATIVO */}
                    <div className="field">
                        <label>Correlativo</label>
                        <div className="input-box">
                            <FontAwesomeIcon icon={faFileInvoice} className="input-icon" />
                            <input value={correlativo} readOnly disabled />
                        </div>
                    </div>

                    {/* CLIENTE */}
                    <div className="field">
                        <label>Cliente</label>
                        <div className="search-box-client">
                            <FontAwesomeIcon icon={faSearch} className="search-icon" />
                            <input
                                placeholder="Buscar cliente..."
                                value={clienteBusqueda}
                                onChange={(e) => {
                                    setClienteBusqueda(e.target.value);
                                    setMostrarClientes(true);
                                }}
                            />

                            {mostrarClientes && clienteBusqueda && clientesFiltrados.length > 0 && (
                                <div className="dropdown">
                                    {clientesFiltrados.slice(0, 6).map(c => (
                                        <div
                                            key={c.idcliente}
                                            className="dropdown-item"
                                            onClick={() => seleccionarCliente(c)}
                                        >
                                            {`${c.nombre || ""} ${c.apellido || ""}`.trim() || c.razonsocial}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* RAZÓN SOCIAL */}
                    <div className="field">
                        <label>Razón Social</label>
                        <div className="input-box">
                            <FontAwesomeIcon icon={faUser} className="input-icon" />
                            <input
                                value={clienteId ? clientes.find(c => c.idcliente === clienteId)?.razonsocial || "" : ""}
                                readOnly
                            />
                        </div>
                    </div>

                    {/* DOCUMENTO */}
                    <div className="field">
                        <label>RUC</label>
                        <div className="input-box">
                            <FontAwesomeIcon icon={faUser} className="input-icon" />
                            <input value={documento} readOnly />
                        </div>
                    </div>

                    {/* DIRECCIÓN */}
                    <div className="field">
                        <label>Dirección</label>
                        <div className="input-box">
                            <FontAwesomeIcon icon={faMapMarkerAlt} className="input-icon" />
                            <input
                                value={direccion}
                                onChange={(e) => setDireccion(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* SERVICIO */}
                    <div className="field">
                        <label>Servicio</label>
                        <div className="input-box">
                            <FontAwesomeIcon icon={faTruck} className="input-icon" />
                            <input value={servicio} readOnly />
                        </div>
                    </div>

                    {/* MONTAJE */}
                    <div className="field">
                        <label>Fecha montaje</label>
                        <div className="input-box">
                            <FontAwesomeIcon icon={faCalendar} className="input-icon" />
                            <input type="date" value={montaje} onChange={(e) => setMontaje(e.target.value)} />
                        </div>
                    </div>

                    {/* DESMONTAJE */}
                    <div className="field">
                        <label>Fecha desmontaje</label>
                        <div className="input-box">
                            <FontAwesomeIcon icon={faCalendar} className="input-icon" />
                            <input type="date" value={desmontaje} onChange={(e) => setDesmontaje(e.target.value)} />
                        </div>
                    </div>

                    {/* BOTÓN */}
                    <button className="btn-completar" onClick={guardar}>
                        COMPLETAR
                    </button>

                </div>
            </div>

            {
                mostrarModalItem && (
                    <div className="modal-overlay">

                        <div className="modal-item">

                            <h3>Agregar Item Personalizado</h3>

                            <div className="field">
                                <label>Descripción</label>

                                <input
                                    type="text"
                                    value={itemDescripcion}
                                    onChange={(e) =>
                                        setItemDescripcion(e.target.value)
                                    }
                                />
                            </div>

                            <div className="field">
                                <label>Precio</label>

                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={itemPrecio}
                                    onChange={(e) =>
                                        setItemPrecio(e.target.value)
                                    }
                                />
                            </div>

                            <div className="field">
                                <label>Cantidad</label>

                                <input
                                    type="number"
                                    min="1"
                                    value={itemCantidad}
                                    onChange={(e) =>
                                        setItemCantidad(e.target.value)
                                    }
                                />
                            </div>

                            <div className="modal-actions">

                                <button
                                    className="btn-cancelar"
                                    onClick={() =>
                                        setMostrarModalItem(false)
                                    }
                                >
                                    Cancelar
                                </button>

                                <button
                                    className="btn-guardar"
                                    onClick={agregarItemPersonalizado}
                                >
                                    Agregar
                                </button>

                            </div>

                        </div>

                    </div>
                )
            }
        </div>
    );
}